// removed by extract-text-webpack-plugin
module.exports = {"video":"_2Pi8597X2KHYxcf2_6qIAR","-theme-default":"_20WZeZ4zf32Jz06wtQzfbx","-theme-full":"_2IWBo7cJokImfJ7sUsZpTc","iframe":"hIeZvRMqU1C7GjsUS_TTc","appear":"-cPGThMkkrAnY_9e-iiXt","play":"_2DzVX69Sz3PT4CeC9JRjVC","title":"_1yjcTQnDqwYMZ4iYJGeVhz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VideoPlayer/VideoPlayer.module.scss
// module id = 817
// module chunks = 0